import type { HttpInterceptor } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import type { InjectionToken, Type } from '@angular/core';

import { DebuggingInterceptor } from './lib/debug.ssr.interceptor';
import { ErrorInterceptor } from './lib/error.interceptor';
import { ErrorSsgInterceptor } from './lib/error.ssr.interceptor';

export const httpInterceptorProviders = (
  isProd = false,
): Array<{ useClass: Type<HttpInterceptor>; provide: InjectionToken<HttpInterceptor[]>; multi: boolean }> => {
  return [
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true, isDemo: false },
    { provide: HTTP_INTERCEPTORS, useClass: DebuggingInterceptor, multi: true, isDemo: false },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorSsgInterceptor, multi: true, isDemo: false },
  ]
    .filter(({ isDemo }) => !isProd || isDemo !== isProd)
    .map(({ isDemo, ...payload }) => payload);
};
